/**
 * Meridian wall-clock timeouts — public surface.
 *
 * Two halves that only work together:
 *   - `./budgets`      — the numbers, each derived from a route's Vercel `maxDuration`.
 *   - `./tool-timeout` — the enforcement, because the SDK's own tool timeout is cooperative and
 *                        no Meridian tool reads `abortSignal`.
 */

export {
  AGENT_DEFAULT_TOTAL_TIMEOUT_MS,
  AGENT_STREAMING_TOTAL_TIMEOUT_MS,
  BACKSTOP_GRACE_MS,
  DEFAULT_TOOL_TIMEOUT_MS,
  DELEGATION_TOOL_TIMEOUT_MS,
  STREAM_STEP_TIMEOUT_MS,
  buildStreamTimeout,
  resolveAgentTimeouts,
  streamToolTimeoutsMs,
  streamTotalTimeoutMs,
  toolTimeoutOverridesFromEnv,
  type AgentTimeouts,
} from './budgets.js';

export {
  ToolTimeoutError,
  withToolTimeout,
  withToolTimeouts,
  type ToolTimeoutOptions,
} from './tool-timeout.js';

export { isTimeoutAbortError } from './abort-detection.js';
